import { _js } from '@ifixit/utils/localize';
import { faQuoteLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const BlockquoteButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBlockquote().run()}
         isActive={editor.isActive('blockquote')}
         isDisabled={!editor.can().toggleBlockquote()}
         icon={<FontAwesomeIcon icon={faQuoteLeft} />}
         title={_js('Insert a quote')}
         shortcut={'shift+b'}
      />
   );
};
